import React, { useState, useEffect } from 'react';
import CheckAuth from '../../elements/checkAuth';
import Menu from '../../elements/Menu/menu';
import PageMode from '../../elements/PageMode/pageMode';
import axios from 'axios';
import config from '../../../../config/environment';
import './pushNotifications.css';

const MODES = ['BROADCAST', 'INDIVIDUAL', 'UPDATE'];
const INDIVIDUAL_MODES = [ 'USER', 'COUNTRY' ];
const LOCALES = [ 'EN', 'RU', 'UK' ];

export default function PushNotifications() {
    const [state, setState] = useState({
        mode: 'BROADCAST',
        individualMode: 'USER',
        pushObj: null,

        recipient: '',
        cashbackToken: '',
        isUserCreated: true,
        locale: null,

        notificationGroupsArray: [],
        notificationGroup: null,
        notificationGroupsNew: '',
        notificationNamesArray: [],
        notificationName: null,
        notificationNamesNew: '',

        url: '',
        priority: null,
        currencyCode: '',
        customCreated: null,
        isNeedPopUp: false,
        sendWithoutPush: false,
        sendToOldVersion: true,

        serverId: '',
        notificationStatus: null,
        isError: false,
        errorMessage: 'Get notification data first',

        countriesArray: null,
        country: null,

        urlMultilingualCheckbox: false,
        urlMultilingual: null,
    });

    useEffect(() => {
        const main = async () => {
            const pushObj = {};
            const urlMultilingual = {};
            LOCALES.map(locale => {
                pushObj[locale.toLowerCase()] = { title: '', message: '' };
                urlMultilingual[locale.toLowerCase()] = '';
            });
    
            const [ responseGroups, responseNames ] = await Promise.all([
                axios.get(config.notificationsUrl + '/setting/get?settingKey=notificationGroups'),
                axios.get(config.notificationsUrl + '/setting/get?settingKey=notificationNames')
            ]);
    
            setState(state => { return {
                ...state,
                pushObj, urlMultilingual,
                notificationGroupsArray: responseGroups.data,
                notificationNamesArray: responseNames.data
            } });
        };
        main();
    }, []);

    const modeOnChangeHandler = (event) => {
        setState({
            ...state,
            mode: event.target.value,
            recipient: '',
            cashbackToken: '',
            isUserCreated: true,
            locale: null,
            serverId: '',
            notificationData: null,
            isError: event.target.value === 'UPDATE',
            errorMessage: 'Get notification data first'
        });
    };

    const individualModeOnChangeHandler = async (event) => {
        setState({
            ...state,
            individualMode: event.target.value,
            recipient: '',
            cashbackToken: '',
            isUserCreated: true,
            locale: null,
            serverId: '',
            notificationData: null,
            isError: event.target.value === 'UPDATE',
            errorMessage: 'Get notification data first'
        });
    };

    // --- Notification data ---
    const renderNotificationData = () => {
        if (state.mode !== 'UPDATE') { return; }

        return(
            <>
                <div className="pushNotification__functionalLabel">Notification data</div>
                <hr/>
                <div className="pushNotification__notificationData_wrapper">
                    <input className="pushNotification__recipientUserData_locale" type="text" value={ state.serverId } placeholder="server id" onChange={ serverIdChangeHandler }/>
                    <button className="pushNotification__recipientUserData_locale" onClick={ getButtonHandler }>Get</button>
                    { state.notificationStatus ? <button onClick={ deleteButtonHandler } >Delete</button> : null }
                </div>
            </>
        );
    };

    const serverIdChangeHandler = (event) => setState({ ...state, serverId: event.target.value });

    const getButtonHandler = async () => {
        if (!state.serverId) {
            alert('Invalid server id');
            return;
        }

        const token2fa = prompt('Enter 2FA');
        if (!token2fa) {
            alert('Invalid 2FA');
            return;
        }

        await axios.get(config.notificationsUrl + '/notifications/get?notificationServerId=' + state.serverId +'&token2fa=' + token2fa)
        .then(response => {
            const resData = response.data;

            if (!resData.data || !resData.data.notification) {
                setState(state => { return { ...state, isError: true, errorMessage: 'Notification has invalid data' }; });
                return;
            }

            if (resData.status === '33') {
                setState(state => { return { ...state, isError: true, errorMessage: 'Notification was deleted' }; });
                return;
            }

            const pushObj = {};
            for (const locale in resData.data.notification) {
                pushObj[ locale ] = {
                    title: resData.data.notification[ locale ].title,
                    message: resData.data.notification[ locale ].description
                };
            }

            setState(state => { return {
                ...state,
                isError: false,
                pushObj,
                currencyCode: resData.currencyCode || '',
                customCreated: resData.customCreated || null,
                notificationGroup: resData.group || null,
                notificationName: resData.name || null,
                isNeedPopUp: typeof resData.needPopUp !== 'undefined' ? resData.needPopUp : false,
                priority: resData.priority || null,
                url: resData.url || '',
                notificationStatus: resData.status
            }; });
        })
        .catch(error => setState(state => { return { ...state, isError: true, errorMessage: error.response.data.message }; }));
    };

    const deleteButtonHandler = async () => {
        const token2fa = prompt('Enter 2FA');
        if (!token2fa) {
            alert('Invalid 2FA');
            return;
        }

        const body = { notificationServerId: state.serverId, token2fa };

        axios.post(config.notificationsUrl + '/notifications/delete', body)
        .then(() => setState(state => { return { ...state, isError: true, errorMessage: 'Notification was deleted' }; }))
        .catch(error => {
            console.log(error);
            console.log(error.response.data);
            alert(error.message);
        });
    };

    // --- Error ---
    const renderError = () => {
        if (!state.isError) { return; }

        return(
            <div>
                <div className="pushNotification__functionalLabel">Error</div>
                <hr/>
                <div className="pushNotification__error_wrapper">{ state.errorMessage }</div>
            </div>
        );
    };

    // --- Push Text ---
    const renderPushData = () => {
        if (state.isError) { return; }

        return(
            <div>
                <div className="pushNotification__functionalLabel">Notification</div>
                <hr/>
                <div className="pushNotifications__pushData_wrapper">
                    {
                        LOCALES.map((locale, index) => {
                            return(
                                <div className="pushNotifications__pushData_localeWrapper">
                                    <span>{ locale }</span>
                                    <div className="pushNotifications__pushData_inputsWrapper">
                                        <input className="pushNotifications__pushData_title" type="text" placeholder="title*"
                                            value={ state.pushObj ? (state.pushObj[locale.toLowerCase()].title || '') : '' }
                                            onChange={ pushInputChangeHandler(locale.toLowerCase(), 'title') } />
                                        <textarea className="pushNotifications__pushData_message" type="text" placeholder={ 'message' + (locale === 'EN' ? '' : '*') }
                                            value={ state.pushObj ? (state.pushObj[locale.toLowerCase()].message || '') : '' }
                                            onChange={ pushInputChangeHandler(locale.toLowerCase(), 'message') } />
                                        {
                                            state.urlMultilingualCheckbox ?
                                                <input className="pushNotifications__pushData_title" type="text" placeholder={ locale.toLowerCase() + ' url' + (locale === 'EN' ? '' : '*') }
                                                    value={ state.urlMultilingual ? (state.urlMultilingual[locale.toLowerCase()] || '') : '' }
                                                    onChange={ urlMultilingualInputChangeHandler(locale.toLowerCase()) } />
                                                : null
                                        }
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    };

    const pushInputChangeHandler = (locale, key) => (event) => {
        const pushObj = { ...state.pushObj };
        pushObj[locale][key] = event.target.value;
        setState(state => { return { ...state, pushObj }; });
    };

    const urlMultilingualInputChangeHandler = (locale) => (event) => {
        const urlMultilingual = { ...state.urlMultilingual };
        urlMultilingual[locale] = event.target.value;
        setState(state => { return { ...state, urlMultilingual }; });
    };

    // --- Push Data ---
    const renderPushParams = () => {
        if (state.isError) { return; }

        return(
            <div>
                <div className="pushNotification__functionalLabel">Params</div>
                <hr/>
                <div className="pushNotifications__pushParams_wrapper">
                    { renderRecipient() }
                    { renderGroups() }
                    { renderNames() }
                    { renderAnotherParams() }
                    <button onClick={ sendButtonHandler }>Send</button>
                </div>
            </div>
        );
    };
    
    // Recipient
    const renderRecipient = () => {
        if (state.mode === 'UPDATE') { return; }

        return(
            <div className="pushNotification__recipient_wrapper">
                {
                    state.mode === 'BROADCAST' ?
                        <div>
                            <input type="text" value={ state.recipient } onChange={ recipientChangeHandler } placeholder="topic*"/>
                        </div>
                        :
                        <div className="pushNotification__recipientIndividual_wrapper">
                            <PageMode radioName="individualModes" modesArray={ INDIVIDUAL_MODES } checkedMode={ state.individualMode } onChangeHandler={ individualModeOnChangeHandler } />
                            {
                                state.individualMode === 'USER' ?
                                    <>
                                        <input type="text" value={ state.cashbackToken } onChange={ cashbackTokenHandler } placeholder="cashback token"/>
                                        {
                                            !state.isUserCreated ?
                                            <div className="pushNotification__recipientUserData_wrapper">
                                                <input type="text" className="pushNotification__recipientUserData_deviceToken" onChange={ recipientChangeHandler } placeholder="device token"/>
                                                <select className="pushNotification__recipientUserData_locale" value={ state.locale || 'DEFAULT' } onChange={ localeSelectChangeHandler }>
                                                    <option value="DEFAULT" disabled>Select locale</option>
                                                    {
                                                        LOCALES.map((value, index) => {
                                                            return(
                                                                <option value={ value }>{value}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                                <button onClick={ addUserButtonHandler } >Add</button>
                                            </div>
                                            : null
                                        }
                                    </>
                                    : <>{ renderCountrySelect() }</>
                            }
                        </div>
                }
            </div>
        );
    };

    const recipientChangeHandler = (event) => setState({ ...state, recipient: event.target.value });

    const cashbackTokenHandler = async (event) => {
        const cashbackToken = event.target.value.slice(0, 8);
        setState({ ...state, cashbackToken });

        if (cashbackToken.length === 8) {
            await axios.get(config.notificationsUrl + '/user/get?cashbackToken=' + cashbackToken)
            .then(response => setState(state => { return { ...state, isUserCreated: response.data.isCreated }; }))
            .catch(error => {
                console.log(error);
                alert(error.message);
            });
        }
    };

    const localeSelectChangeHandler = async (event) => setState({ ...state, locale: event.target.value });

    const addUserButtonHandler = async () => {
        if (!state.recipient) {
            alert('Invalid recipient');
            return;
        }

        if (!state.locale) {
            alert('Invalid locale');
            return;
        }

        const token2fa = prompt('Enter Google 2FA');
        if (!token2fa) {
            alert('Invalid Google 2FA');
            return;
        }

        const body = {
            cashbackToken: state.cashbackToken,
            deviceToken: state.recipient,
            locale: state.locale,
            token2fa
        };

        await axios.post(config.notificationsUrl + '/user/create', body)
        .then(response => {
            alert(response.data.message);
            setState(state => { return { ...state, isUserCreated: true }; })
        })
        .catch(error => {
            console.log(error);
            alert(error.message);
        })
    };

    // Country flow
    const renderCountrySelect = () => {
        return(
            <div>
                <select value={ state.country || 'DEFAULT' } onChange={ countrySelectChangeHandler }>
                    <option value="DEFAULT" disabled>Select country</option>
                    {
                        state.countriesArray ? 
                            state.countriesArray.map((value, index) => {
                                return(
                                    <option value={ value }>{value}</option>
                                );
                            })
                            : null
                    }
                </select>
                <button style={{ marginLeft: '5px' }} onClick={ getCountries }>Get countries</button>
            </div>
        );
    };
    
    const getCountries = async () => {
        const response = await axios.get(config.backendUrl + '/ksu-crypto/users-countries', { headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
        } });

        setState(state => { return { ...state, countriesArray: response.data.countries } });
    };

    const countrySelectChangeHandler = (event) => setState({ ...state, country: event.target.value });

    // Groups
    const renderGroups = () => {
        const paramName = 'notificationGroups';

        return(
            <div className="pushNotification__groups_wrapper">
                <select value={ state[ paramName.slice(0, -1) ] || 'DEFAULT' } onChange={ groupAndNameSelectChangeHandler(paramName) }>
                    <option value="DEFAULT">--- Select group ---</option>
                    {
                        state[ paramName + 'Array' ].map((group, index) => {
                            return(
                                <option value={ group }>{ group }</option>
                            );
                        })
                    }
                    <option value="ADD">--- add new group ---</option>
                </select>
                {
                    state[ paramName.slice(0, -1) ] === 'ADD' ?
                        <div className="pushNotification__groupsAdd_wrapper">
                            <input className="pushNotification__recipientUserData_locale" type="text" placeholder="group"
                                value={ state[ paramName + 'New' ] } onChange={ settingChangeHandler(paramName) } />
                            <button onClick={ addSettingButtonHandler(paramName) }>Add</button>
                        </div>
                        : null
                }
            </div>
        )
    };

    const groupAndNameSelectChangeHandler = (paramName) => (event) => {
        const newState = { ...state };
        newState[ paramName.slice(0, -1) ] = event.target.value !== 'DEFAULT' ? event.target.value : null;
        setState(newState);
    };

    const settingChangeHandler = (paramName) => (event) => {
        const newState = { ...state };
        newState[paramName + 'New'] = event.target.value;
        setState(newState);
    };

    const addSettingButtonHandler = (paramName) => async () => {
        if (!state[ paramName + 'New' ]) {
            alert('Invalid ' + paramName);
            return;
        }

        const settings = {};
        settings[ paramName ] = state[ paramName + 'New' ];

        const token2fa = prompt('Enter Google 2FA');
        if (!token2fa) {
            alert('Invalid Google 2FA');
            return;
        }

        const body = { settings, token2fa };

        await axios.post(config.notificationsUrl + '/setting/update', body)
        .then(response => {
            const newState = { ...state };
            newState[ paramName + 'Array' ] = response.data[ paramName ];
            newState[ paramName.slice(0, -1) ] = state[ paramName + 'New' ].replaceAll(' ', '_').toUpperCase();
            setState(() => { return newState; });
        })
        .catch(error => {
            console.log(error);
            alert(error.message);
        });
    };

    // Names
    const renderNames = () => {
        const paramName = 'notificationNames';

        return(
            <div className="pushNotification__groups_wrapper">
                <select value={ state[ paramName.slice(0, -1) ] || 'DEFAULT' } onChange={ groupAndNameSelectChangeHandler(paramName) }>
                    <option value="DEFAULT" disabled>--- Select name ---</option>
                    {
                        state[ paramName + 'Array' ].map((name, index) => {
                            return(
                                <option value={ name }>{ name }</option>
                            );
                        })
                    }
                    <option value="ADD">--- add new group ---</option>
                </select>
                {
                    state[ paramName.slice(0, -1) ] === 'ADD' ?
                        <div className="pushNotification__groupsAdd_wrapper">
                            <input className="pushNotification__recipientUserData_locale" type="text" placeholder="name"
                                value={ state[ paramName + 'New' ] } onChange={ settingChangeHandler(paramName) } />
                            <button onClick={ addSettingButtonHandler(paramName) }>Add</button>
                        </div>
                        : null
                }
            </div>
        )
    };

    // Another params
    const renderAnotherParams = () => {
        return(
            <div className="pushNotification__anotherParams_wrapper">
                <div className="pushNotification__anotherParams_elementWrapper pushNotification__displayFlex_direction_column">
                    {
                        state.urlMultilingualCheckbox ? null :
                            <input type="text" className="pushNotification__anotherParams_input" placeholder="url*"
                                value={ state.url } onChange={ anotherParamsInputChangeHandler('url') }/>
                    }
                    <div>
                        <input type="checkbox" id="urlMultilingualCheckbox" checked={ state.urlMultilingualCheckbox } onChange={ anotherParamsCheckboxChangeHandler('urlMultilingualCheckbox') } />
                        <label htmlFor="urlMultilingualCheckbox">enable multilingual</label>
                    </div>
                </div>
                <div className="pushNotification__anotherParams_elementWrapper">
                    <input type="number" className="pushNotification__anotherParams_input" placeholder="priority*" min="0"
                        onChange={ anotherParamsInputChangeHandler('priority') } value={ state.priority || '' }/>
                </div>
                <div className="pushNotification__anotherParams_elementWrapper">
                    <input type="text" className="pushNotification__anotherParams_input" placeholder="currency code*"
                        value={ state.currencyCode } onChange={ anotherParamsInputChangeHandler('currencyCode') }/>
                </div>
                <div className="pushNotification__anotherParams_elementWrapper">
                    <input type="number" min="0" className="pushNotification__anotherParams_input" placeholder="custom created timestamp*"
                        value={ state.customCreated || '' } onChange={ anotherParamsInputChangeHandler('customCreated') }/>
                </div>
                <div className="pushNotification__anotherParams_elementWrapper">
                    <input type="checkbox" onChange={ anotherParamsCheckboxChangeHandler('isNeedPopUp') } checked={ state.isNeedPopUp } />
                    <span>is need PopUp?*</span>
                </div>
                {
                    state.mode !== 'UPDATE' ?
                        <>
                            <div className="pushNotification__anotherParams_elementWrapper">
                                <input type="checkbox" onChange={ anotherParamsCheckboxChangeHandler('sendWithoutPush') } checked={ state.sendWithoutPush } />
                                <span>send without push?*</span>
                            </div>
                            <div className="pushNotification__anotherParams_elementWrapper">
                                <input type="checkbox" onChange={ anotherParamsCheckboxChangeHandler('sendToOldVersion') } checked={ state.sendToOldVersion } />
                                <span>send to old versions?*</span>
                            </div> 
                        </> : null
                }
            </div>
        );
    };

    const anotherParamsInputChangeHandler = (paramName) => (event) => {
        const newState = { ...state };
        newState[ paramName ] = event.target.value;
        setState(newState);
    };

    const anotherParamsCheckboxChangeHandler = (paramName) => (event) => {
        const newState = { ...state };
        newState[ paramName ] = event.target.checked;
        setState(newState);
    };

    // Send logic
    const sendButtonHandler = async () => {
        const body = await getSendBody();
        if (!body) { return; }

        if (body.type === 'UPDATE') { body.notificationServerId = state.serverId; }

        console.log(body);

        body.type !== 'UPDATE' ?
            await axios.post(config.notificationsUrl + '/notifications/send', body)
            .then(response => alert(response.data.message))
            .catch(error => {
                console.log(error.message);
                alert(error.message);
            })
            :
            await axios.post(config.notificationsUrl + '/notifications/update', body)
            .then(response => alert(response.data.message))
            .catch(error => {
                console.log(error);
                console.log(error.response.data.message);
                alert(error.message);
            });
    };

    const getSendBody = async () => {
        if (!state.pushObj.en.message) {
            alert('Invalid EN message');
            return;
        }

        if (!state.notificationName || state.notificationName === 'ADD') {
            alert('Invalid name');
            return;
        }

        const body = {
            type: state.mode,
            pushObj: state.pushObj,
            name: state.notificationName,
            text: state.pushObj.en.message,
            source: 'ADMIN_PAGE',
            needPopUp: state.isNeedPopUp,
            sendWithoutPush: state.sendWithoutPush,
            sendToOldVersion: state.sendToOldVersion
        };
        if (state.notificationGroup && state.notificationGroup !== 'ADD') {
            body.group = state.notificationGroup 
        };
        if (state.pushObj.en.title) {
            body.title = state.pushObj.en.title;
        }
        if (state.urlMultilingualCheckbox) {
            if (!state.urlMultilingual.en) {
                alert('Invalid EN url');
                return;
            }

            const urlMultilingual = {};
            for (let key in state.urlMultilingual) {
                if (state.urlMultilingual[key]) {
                    urlMultilingual[key] = state.urlMultilingual[key];
                }
            }

            body.urlMultilingual = urlMultilingual;
        } else if (state.url) {
            body.url = state.url;
        }
        if (state.currencyCode) {
            body.currencyCode = state.currencyCode;
        }
        if (parseInt(state.priority)) {
            body.priority = parseInt(state.priority);
        }
        if (parseInt(state.customCreated)) {
            body.customCreated = parseInt(state.customCreated);
        }

        if (state.mode === 'BROADCAST') {
            if (state.notificationGroup && state.notificationGroup === 'RATES_CHANGING') { body.recipient = 'exchangeRates'; }
            else if (state.notificationGroup && state.notificationGroup === 'NEWS') { body.recipient = 'news'; }
            else { body.recipient = state.recipient || 'trusteeAll'; }
        }
        
        if (state.mode === 'INDIVIDUAL') {
            if (state.individualMode === 'USER') {
                if (!state.cashbackToken) {
                    alert('Invalid cashbackToken');
                    return;
                }

                body.cashbackToken = state.cashbackToken;
            }
            if (state.individualMode === 'COUNTRY') {
                if (!state.country) {
                    alert('Invalid country');
                    return;
                }

                alert('The system will now find users in ' + state.country + '. Please wait for the 2FA input field.');
                body.cashbackToken = 'COUNTRY_FLOW';
                const response = await axios.get(config.backendUrl + '/ksu-crypto/users-from-country?country=' + state.country, { headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
                } });
                body.users = response.data.users;
            }
        }

        const token2fa = prompt('Enter 2FA');
        if (!token2fa) {
            alert('Invalid 2FA');
            return;
        }
        body.token2fa = token2fa;

        return body;
    };

    return(
        <>
            <CheckAuth />
            <Menu />
            <div>
                <PageMode modesArray={ MODES } checkedMode={ state.mode } onChangeHandler={ modeOnChangeHandler } />
                { renderNotificationData() }
                { renderError() }
                { renderPushData() }
                { renderPushParams() }
            </div>
        </>
    );
}